import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { get, capitalize, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

const SideSpecializedBusinesses = ({ classes, user, obfuscateView }) => {
  if (!isEmpty(get(user, 'specialized_businesses'))) {
    const specializedBusinesses = get(user, 'specialized_businesses', []).map(p => capitalize(p.replaceAll('_', ' ')));
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.specialized_businesses"/></strong>
        {!obfuscateView && (
          <p>
            {specializedBusinesses.map(s => (
              <span>
                {s}
                <br />
              </span>
            ))}
          </p>
        )}
        {obfuscateView && <p className="blurry-text">???</p>}
      </div>
    );
  }
  return <div />;
};

const styles = {
  status : {
    marginBottom : 15,
    width        : 170,
  },
};

export default withStyles(styles)(SideSpecializedBusinesses);
